// Tri et filtres de la liste des points, gardés dans l'URL (paramètres de
// requête : recharger ou partager garde la vue). Le tri se fait côté API
// (liste blanche zod) ; ces fonctions ne font que lire et écrire l'URL.
export const SORT_COLUMNS = ['id', 'type', 'priorite', 'date', 'client', 'etat'] as const;
export type SortColumn = (typeof SORT_COLUMNS)[number];
export type SortDir = 'asc' | 'desc';

export const SORT_LABELS: Record<SortColumn, string> = {
  id: 'N°',
  type: 'Type',
  priorite: 'Priorité',
  date: 'Date',
  client: 'Client',
  etat: 'État',
};

export interface ListSort {
  sort: SortColumn | null;
  dir: SortDir;
}

export function readSort(params: URLSearchParams): ListSort {
  const s = params.get('sort');
  const sort = (SORT_COLUMNS as readonly string[]).includes(s ?? '') ? (s as SortColumn) : null;
  return { sort, dir: params.get('dir') === 'desc' ? 'desc' : 'asc' };
}

/** Clic sur un en-tête : même colonne → sens inversé ; autre colonne → croissant. */
export function nextSort(current: ListSort, col: SortColumn): { sort: SortColumn; dir: SortDir } {
  if (current.sort === col) return { sort: col, dir: current.dir === 'asc' ? 'desc' : 'asc' };
  return { sort: col, dir: 'asc' };
}

/** Copie des paramètres avec ces valeurs (null ou '' : paramètre retiré). */
export function withParams(params: URLSearchParams, changes: Record<string, string | null>): URLSearchParams {
  const next = new URLSearchParams(params);
  for (const [k, v] of Object.entries(changes)) {
    if (v === null || v === '') next.delete(k);
    else next.set(k, v);
  }
  return next;
}

/** Recherche sans accents ni casse : « alg » trouve « Algoé ». */
export function normalizeSearch(s: string): string {
  return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
}

export function matchClients<T extends { nom_client: string }>(clients: readonly T[], text: string, max = 8): T[] {
  const q = normalizeSearch(text);
  if (!q) return clients.slice(0, max);
  const starts: T[] = [];
  const contains: T[] = [];
  for (const c of clients) {
    const n = normalizeSearch(c.nom_client);
    if (n.startsWith(q)) starts.push(c);
    else if (n.includes(q)) contains.push(c);
  }
  return [...starts, ...contains].slice(0, max);
}
